import React from "react";
import Button from "@material-ui/core/Button";
import GoogleIcon from "../google";
import "../styles/Login.css";
import { withRouter } from "react-router";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { login } = this.props;
    return (
      // const Login = ({ login, logOut, annonymousLogin, classes }) => (

      <div
        style={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Button
          style={{
            display: "flex",
            flexDirection: "row",
            backgroundColor: "white"
          }}
          variant="contained"
          onClick={
            e => {
              e.preventDefault();
              login(this.props);
              this.props.history.push("/loading");
            }}
          size="medium"
        >
          <GoogleIcon style={{ height: "25px", marginRight: "10px" }} />
          Login With Google
    </Button>
      </div>
    );
  }
}

export default withRouter(Login);